import { FunctionComponent, ReactElement, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ChangePassword from '../components/ChangePassword';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPassword: FunctionComponent = (): ReactElement => {
	const [queryParams] = useSearchParams();
	const token = useMemo(() => queryParams.get('token'), [queryParams]);

	if (token) {
		return <ChangePassword type="update" token={token} navigateAfterSuccess="/auth/login" />;
	}

	return <ForgotPasswordForm />;
};

export default ForgotPassword;
